










































































import Vue from 'vue';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { PageBanner } from '@/components/page-components';
import { MemberMessageResponseModel } from '@/@types/member';

interface Data {
  showMoreMessages: boolean;
}

export default Vue.extend({
  name: 'NotificationsPage',
  beforeRouteEnter(to, from, next) {
    const promises = store.dispatch('getNotifications');
    return LoadingService.watchPromises(promises)
      .then(next)
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      showMoreMessages: false,
    };
  },
  mounted() {
    if (
      (this.$refs.notificationsContainer as any).$el.clientHeight >=
      window.innerHeight / 2
    ) {
      this.showMoreMessages = true;
    }
  },
  computed: {
    notifications(): MemberMessageResponseModel[] {
      if (this.$store.getters.notifications) {
        return this.$store.getters.notifications;
      }
    },
  },
  methods: {
    markAsRead(notification): void {
      if (!notification.isReadIndicator) {
        // set to true so can't double-click message which calls API twice, resulting in two read messages
        notification.isReadIndicator = true;
        this.$store.dispatch('markNotificationAsRead', notification.messageId);
      }
    },
  },
  components: {
    PageBanner,
  },
});
